const translations: Record<string, string> = {
  "ak_ev_total_loss_of_generation": "Повна втрата генерації",
  "ak_ev_no_link_collector_is_silent": "Відсутній звʼязок (колектор мовчить)",
  "ak_ev_partial_loss_inverters_offline": "Часткова втрата — інвертори offline",
  "ak_ev_portfolio": "Портфель",
};

export default translations;
